<template>
  <div ref="bing" class="bing"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: "Bing2",
  data() {
    return{
      data:{},
      option : {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          left: "10%",
          top: "10%",
          orient: "vertical",
          textStyle:{
            color:"#fff"
          }
        },
        series: [
          {
            name: '营收额',
            left: '20%',
            top: '15%',
            height:"85%",
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '26',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              { value: 1048, name: '驻马店' },
              { value: 735, name: '汝南' },
              { value: 580, name: '漯河' },
              { value: 484, name: '西平' },
              { value: 300, name: '许昌' }
            ]
          }
        ]
      }
    }
  },
  methods: {
    init() {
      this.myChart = echarts.init(this.$refs.bing);
      this.myChart.setOption(this.option);
    },
  },
  mounted() {
    let user_id = window.localStorage.getItem('user_id');

    const data = {
      'user_id': user_id
    };

    this.$api.zq_fp_ranking1(data).then(res=>
    {
      // console.log(res);
      this.option ={
        tooltip: {
          trigger: 'item'
        },
        legend: {
          left: "55%",
          top: "20%",
          orient: "vertical",
          textStyle:{
            color:"#fff"
          }
        },
        series: [
          {
            name: '营收额',
            left: '-35%',
            top: '10%',
            height:"60%",
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '26',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: res
          }
        ]
      }
      this.myChart = echarts.init(this.$refs.bing);
      this.myChart.setOption(this.option);
    })
  },
  watch: {
    data(value) {
      this.option.data = value;
      this.myChart.setOption(this.option);
    },
  }
}
</script>

<style scoped>
 .bing{
   height: 100%;
   width: 100%;
 }
</style>